export const ADD_USER_INFO = 'user/ADD_USER_INFO';
export const REMOVE_USER_INFO = 'user/REMOVE_USER_INFO';

const initialState = {
    userInfo: {isSignedIn: false}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_USER_INFO:
            return {
                ...state,
                userInfo: action.data
            };
        case REMOVE_USER_INFO:
            return {
                ...state,
                userInfo: {isSignedIn: false}
            };
        default:
            return state
    }
}

export const addUserInfo = (userInfo) => {
    return dispatch => {
        dispatch({
            type: ADD_USER_INFO,
            data: userInfo
        });
    }
};

export const removeUserInfo = () => {
    return dispatch => {
        dispatch({
            type: REMOVE_USER_INFO
        });
    }
};